import { useEffect, useState } from "react";
import { decodeToken } from "react-jwt";
import { getCookieToken, getSessionToken } from "utils/helpers";

// Keep widget data local: remount/logout discards it, and each account/period
// has a distinct key. Effect cleanup prevents late responses replacing newer data.
const useReportV2 = (request, params) => {
  const queryKey = JSON.stringify(typeof params === "string" ? { getBy: params } : params || {});
  const token = getSessionToken() || getCookieToken();
  const account = decodeToken(token) || {};
  const accountKey = `${account.companyUuid || ""}:${account.userUuid || ""}`;
  const key = `${accountKey}:${queryKey}`;
  const [state, setState] = useState({});
  const [retryCount, setRetryCount] = useState(0);

  useEffect(() => {
    let active = true;
    setState({ key, loading: true });
    const load = async () => {
      try {
        const response = await request(JSON.parse(queryKey));
        if (!active) return;
        setState({
          key,
          loading: false,
          data: response.success ? response.data : undefined,
          error: response.success ? undefined : response,
        });
      } catch (error) {
        if (active) setState({ key, loading: false, error: { msg: "Report tidak dapat dimuat" } });
      }
    };
    load();
    return () => {
      active = false;
    };
  }, [request, key, queryKey, retryCount]);

  return {
    ...(state.key === key ? state : { loading: true }),
    retry: () => setRetryCount((count) => count + 1),
  };
};

export default useReportV2;
